export type Cluster = "mainnet" | "devnet";
